// import React, { useEffect, useRef, useState } from "react";
// import { Box, Typography, Avatar, Container, Grid } from "@mui/material";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";
// import next_arrow from "../../assets/left_arrow.png";
// import prev_arrow from "../../assets/prev_arrow.png";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import { HeadingText } from "../../utils/CustomTagComponents";
// import VideoPlayer from "../../components/common/VideoPlayer";
// import { useSelector } from "react-redux";
// import { getSuccessStoriesByCountry } from "../../services/SuccessStoryService";

// const StudentStory = () => {
//   const prevRef = useRef(null);
//   const nextRef = useRef(null);
//   // const [swiperInstance, setSwiperInstance] = useState(null);
//   const [navState, setNavState] = useState({ isBeginning: true, isEnd: false });

//   const { country_id } = useSelector((state) => state.auth || {});
//   const [stories, setStories] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchStories = async () => {
//       try {
//         setLoading(true);
//         const { data } = await getSuccessStoriesByCountry(1, 3, country_id);
//         if (data?.success) {
//           setStories(data.data || []);
//         }
//       } catch (err) {
//         console.error("Error fetching success stories:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStories();
//   }, [country_id]);

//   // Don't render if no stories found
//   if (!loading && stories.length === 0) return null;

//   return (
//     <Box sx={{ bgcolor: "#002045" }}>
//       <Container sx={{
//         py: 6, my: { xs: 3, sm: 4, md: 6 },
//         paddingLeft: { xs: "24px !important", md: "48px !important" },
//         paddingRight: { xs: "24px !important", md: "48px !important" },
//       }}>
//         <Grid
//           container
//           alignItems="center"
//           spacing={2}
//           sx={{
//             flexDirection: { xs: "column", sm: "row" }, // stack on mobile
//             textAlign: { xs: "center", sm: "left" },
//           }}
//         >
//           {/* Left Section — Heading */}
//           <Grid size={{ xs: 12, sm: 6 }}>
//             <HeadingText
//               variant="h4"
//               sx={{
//                 fontSize: { xs: "22px", sm: "28px", md: "36px", lg: "40px" },
//                 color: "#ffffff"
//               }}
//             >
//               Success Stories For Student
//             </HeadingText>
//           </Grid>

//           {/* Right Section — Navigation Buttons */}
//           <Grid
//             size={{ xs: 12, sm: 6 }}
//             sx={{
//               display: "flex",
//               justifyContent: { xs: "center", sm: "flex-end" },
//               mt: { xs: 2, sm: 0 },
//             }}
//           >
//             <Box sx={{ display: "flex", gap: 1 }}>
//               {/* Prev Button */}
//               {/* <Box
//                 ref={prevRef}
//                 sx={{
//                   width: 34,
//                   height: 34,
//                   borderRadius: "10px",
//                   backgroundColor: navState.isBeginning ? "#ccc" : "#fd0000",
//                   opacity: navState.isBeginning ? 0.6 : 1,
//                   pointerEvents: navState.isBeginning ? "none" : "auto",
//                   color: "#fff",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                   overflow: "hidden",
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={prev_arrow}
//                   alt="prev"
//                   sx={{
//                     width: 16,
//                     height: 16,
//                     objectFit: "contain",
//                   }}
//                 />
//               </Box> */}
//               <Box
//                 ref={prevRef}
//                 sx={{
//                   width: 34,
//                   height: 34,
//                   borderRadius: "10px",
//                   backgroundColor: navState.isBeginning ? "#ffffff" : "#fd0000",
//                   opacity: navState.isBeginning ? 0.6 : 1,
//                   pointerEvents: navState.isBeginning ? "none" : "auto",
//                   color: "#fff",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                 }}
//               >
//                 <ArrowBackIosNewIcon sx={{ fontSize: 16, color: navState.isBeginning ? "#000" : "#ffffff" }} />
//               </Box>

//               {/* Next Button */}
//               {/* <Box
//                 ref={nextRef}
//                 sx={{
//                   width: 34,
//                   height: 34,
//                   borderRadius: "10px",
//                   backgroundColor: navState.isEnd ? "#ccc" : "#fd0000",
//                   opacity: navState.isEnd ? 0.6 : 1,
//                   pointerEvents: navState.isEnd ? "none" : "auto",
//                   color: "#fff",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                   overflow: "hidden",
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={next_arrow}
//                   alt="next"
//                   sx={{
//                     width: 16,
//                     height: 16,
//                     objectFit: "contain",
//                   }}
//                 />
//               </Box> */}
//               <Box
//                 ref={nextRef}
//                 sx={{
//                   width: 34,
//                   height: 34,
//                   borderRadius: "10px",
//                   backgroundColor: navState.isEnd ? "#ffffff" : "#fd0000",
//                   opacity: navState.isEnd ? 0.6 : 1,
//                   pointerEvents: navState.isEnd ? "none" : "auto",
//                   color: "#fff",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   cursor: "pointer",
//                 }}
//               >
//                 <ArrowForwardIosIcon sx={{ fontSize: 16, color: navState.isEnd ? "#000" : "#ffffff" }} />
//               </Box>
//             </Box>
//           </Grid>
//         </Grid>

//         <Swiper
//           modules={[Navigation]}
//           spaceBetween={30}
//           // slidesPerView={1}
//           // onSwiper={(swiper) => setSwiperInstance(swiper)}
//           onSlideChange={(swiper) =>
//             setNavState({
//               isBeginning: swiper.isBeginning,
//               isEnd: swiper.isEnd,
//             })
//           }
//           navigation={{
//             prevEl: prevRef.current,
//             nextEl: nextRef.current,
//           }}
//           autoplay={false}
//           loop={false}
//           // autoplay={{
//           //     delay: 2000,
//           //     disableOnInteraction: false,
//           // }}
//           onBeforeInit={(swiper) => {
//             swiper.params.navigation.prevEl = prevRef.current;
//             swiper.params.navigation.nextEl = nextRef.current;
//           }}
//           breakpoints={{
//             0: {
//               slidesPerView: 1,
//             },
//             767: { slidesPerView: 1.5 },
//             1024: {
//               slidesPerView: 1.5,
//             },
//           }}
//         >
//           {stories.map((item, index) => (
//             <SwiperSlide key={index}>
//               <Box
//                 sx={{
//                   position: "relative",
//                   display: "flex",
//                   borderRadius: "30px",
//                   py: { xs: 2, sm: 4 },
//                   alignItems: "center",
//                   gap: 2,
//                   flexDirection: { xs: "column", lg: "row" },
//                   // position: "relative",
//                   // mt: { xs: 4, sm: "58px" },
//                   // flexWrap: "wrap",
//                   // height: "100%",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   // gap: { xs: 2, sm: 4, md: 5 },
//                   py: { xs: 2, sm: 4 },
//                   // mt: { xs: 2, sm: 2 },
//                   minHeight: { xs: 380, sm: 420, md: 460, lg: 480 }, // 👈 Ensures same height
//                 }}
//               >
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     top: { xs: "20px", lg: "50%" },
//                     left: { xs: 0, lg: "200px" },
//                     transform: { lg: "translateY(-50%)" },
//                     bgcolor: "#fff",
//                     borderRadius: "40px",
//                     width: { xs: "auto", lg: "78%" },
//                     height: { xs: "auto", lg: "78%" },
//                     zIndex: 1,
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     position: "relative",
//                     zIndex: 2,
//                     flexShrink: 0,
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                   }}
//                 >
//                   {item.story_image_type == "image" ? (
//                     <Box
//                       component="img"
//                       src={item.story_image_url}
//                       alt={item.user_name}
//                       sx={{
//                         width: { xs: "100%", md: 560, lg: 330, xl: 430 },
//                         height: { xs: 200, sm: 280, md: 320 },
//                         objectFit: "cover",
//                         borderRadius: "20px",
//                         zIndex: 2,
//                         display: "block",
//                         mx: "auto", // center align if needed
//                       }}
//                     />
//                   ) : (
//                     <VideoPlayer
//                       src={item.story_image_url}
//                       width={{ xs: "100%", md: 560, lg: 430, xl: 430 }}
//                       height={{ xs: 200, sm: 280, md: 320 }}
//                       iconSize={{ xs: 40, sm: 50, md: 60 }}
//                       borderRadius="20px"
//                       zIndex="2"
//                     />
//                   )}
//                 </Box>
//                 <Box
//                   sx={{
//                     borderRadius: "40px",
//                     padding: {
//                       xs: "30px",
//                       sm: "30px",
//                       lg: "30px",
//                     },
//                     // gap: 3,
//                     bgcolor: { xs: "#fff", lg: "transparent" },
//                     maxWidth: { md: 500 },
//                     flex: 1,
//                     position: "relative",
//                     zIndex: 3,
//                     mt: { xs: 2, lg: 0 },
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "center", // 👈 Centers text vertically
//                   }}
//                 >
//                   <Typography
//                     sx={{
//                       fontSize: { xs: 14, sm: 19 },
//                       color: "#000",
//                       mb: 2,
//                       maxWidth: 400,
//                       fontWeight: 600,
//                       textAlign: "justify"
//                     }}
//                   >
//                     {item.user_message}
//                   </Typography>
//                   <Box display="flex" alignItems="center" gap={2}>
//                     <Avatar
//                       src={item.user_image_url}
//                       alt={item.user_name}
//                       sx={{ width: "54px", height: "54px" }}
//                     />
//                     <Box>
//                       <Typography
//                         sx={{
//                           fontSize: { xs: 14, sm: 19 },
//                           color: "#000",
//                           fontWeight: 700,
//                         }}
//                       >
//                         {item.user_name}
//                       </Typography>
//                       <Typography
//                         sx={{
//                           fontSize: { xs: 13, sm: 16 },
//                           color: "#000",
//                           fontWeight: 400,
//                         }}
//                       >
//                         {item.user_desc}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Box>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </Container>
//     </Box>
//   );
// };

// export default StudentStory;

import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Avatar, Container } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { HeadingText } from "../../utils/CustomTagComponents";
import { useSelector } from "react-redux";
import { getSuccessStoriesByCountry } from "../../services/SuccessStoryService";

import "swiper/css";

const StudentStory = () => {
  const swiperRef = useRef(null);

  const { country_id } = useSelector((state) => state.auth || {});
  const [stories, setStories] = useState([]);

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const { data } = await getSuccessStoriesByCountry(1, 6, country_id);

        if (data?.success) {
          setStories(data.data || []);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchStories();
  }, [country_id]);

  if (stories.length === 0) return null;

  const slides = stories.length < 6 ? [...stories, ...stories] : stories;

  return (
    <Box sx={{ bgcolor: "#f8f9fb", py: { xs: 4, md: 6 } }}>
      <Container
        sx={{
          paddingLeft: { xs: "24px !important", md: "48px !important" },
          paddingRight: { xs: "24px !important", md: "48px !important" },
        }}
      >
        {/* Heading */}
        <HeadingText
          variant="h4"
          sx={{
            textAlign: "center",
            fontSize: { xs: "24px", md: "40px" },
            mb: 3,
          }}
        >
          Success Stories For Student
        </HeadingText>

        {/* Navigation */}
        <Box
          sx={{
            position: "relative",
            maxWidth: 1200,
            mx: "auto",
            px: { xs: 2, md: 4 },
            overflow: "visible",

            "&::before": {
              content: '""',
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: "120px",
              zIndex: 5,
              pointerEvents: "none",
              background:
                "linear-gradient(to right, #f8f9fb 0%, rgba(248,249,251,0) 100%)"
            },

            "&::after": {
              content: '""',
              position: "absolute",
              right: 0,
              top: 0,
              height: "100%",
              width: "120px",
              zIndex: 5,
              pointerEvents: "none",
              background:
                "linear-gradient(to left, #f8f9fb 0%, rgba(248,249,251,0) 100%)"
            }
          }}
        >
          <Box
            onClick={() => swiperRef.current?.slidePrev()}
            sx={{
              position: "absolute",
              top: "50%",
              left: { xs: "0px", md: "160px" },
              transform: "translateY(-50%)",
              zIndex: 10,
              width: 42,
              height: 42,
              borderRadius: "50%",
              bgcolor: "#fff",
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: ".3s",
              "&:hover": { bgcolor: "#111", color: "#fff" },
            }}
          >
            <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
          </Box>

          <Box
            onClick={() => swiperRef.current?.slideNext()}
            sx={{
              position: "absolute",
              top: "50%",
              right: { xs: "0px", md: "160px" },
              transform: "translateY(-50%)",
              zIndex: 10,
              width: 42,
              height: 42,
              borderRadius: "50%",
              bgcolor: "#fff",
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: ".3s",
              "&:hover": { bgcolor: "#111", color: "#fff" },
            }}
          >
            <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
          </Box>


          {/* Swiper */}
          <Swiper
            modules={[Autoplay]}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            slidesPerView={1.4}
            centeredSlides
            spaceBetween={40}
            loop={true}
            watchSlidesProgress
            speed={700}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 1.2,
                spaceBetween: 30
              },
              1200: {
                slidesPerView: 1.4,
                spaceBetween: 40
              }
            }}
          >
            {slides.map((item, index) => (
              <SwiperSlide key={item.id || index}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    transition: "all .4s",
                    transform: "scale(0.92)",
                    filter: "blur(1px)",
                    ".swiper-slide-active &": {
                      transform: "scale(1)",
                      filter: "blur(0px)"
                    }
                  }}
                >
                  <Box
                    sx={{
                      textAlign: "center",
                      maxWidth: 720,
                      width: "100%",
                    }}
                  >
                    {/* Stars */}
                    <Box sx={{ mb: 2 }}>
                      {[1, 2, 3, 4, 5].map((s) => (
                        <span
                          key={s}
                          style={{
                            color: "#ff8c00",
                            fontSize: 18,
                            marginRight: 4,
                          }}
                        >
                          ★
                        </span>
                      ))}
                    </Box>

                    {/* Message */}
                    <Typography
                      sx={{
                        fontSize: { xs: 18, md: 16 },
                        fontWeight: 500,
                        lineHeight: 1.6,
                        color: "#333",
                        mb: 3,
                      }}
                    >
                      “{item.user_message}”
                    </Typography>

                    <Box
                      sx={{
                        width: 180,
                        height: "1px",
                        bgcolor: "#e5e5e5",
                        mx: "auto",
                        mb: 3,
                      }}
                    />

                    {/* User */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <Avatar
                        src={item.user_image_url}
                        sx={{ width: 56, height: 56 }}
                      />

                      <Typography sx={{ fontWeight: 600 }}>
                        {item.user_name}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Container>
    </Box>
  );
};

export default StudentStory;